/**
 * The error a request throws when the server answered and said no.
 *
 * Anything else — offline, DNS, CORS, a timeout — comes back as the original
 * error untouched, so a screen can tell "the server told us why" apart from
 * "we never reached the server" and only ever show a real server message as
 * one. See the note at the top of `lib/api/client.ts`.
 */
export class ApiError extends Error {
  constructor(
    message: string,
    /** The HTTP status the server answered with. */
    readonly status: number,
    /** The parsed body, for the rare caller that needs more than the message. */
    readonly payload?: unknown
  ) {
    super(message);
    this.name = "ApiError";
  }
}

/** What a screen shows for a failure, whichever of the two kinds it was. */
export const errorText = (error: unknown, fallback: string): string =>
  error instanceof ApiError ? error.message : fallback;
